// extracted by css-extract-rspack-plugin
export default {"BetaLabel":"StringField-module__BetaLabel__iiczber"};